const NoResumeHistory = (props) => {
  const { educationList, workHistoryList, noResume } = props;
  return (
    <>
      {noResume && (
        <>
          {workHistoryList?.length ? (
            <>
              {workHistoryList?.some(
                (history) =>
                  history?.name ||
                  history?.fromMonth ||
                  history?.fromYear ||
                  history?.toMonth ||
                  history?.toYear
              ) ? (
                <div>
                  <h4 className="view-heading">Work History</h4>
                  <>
                    <section
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                        gap: "1.5rem",
                      }}
                    >
                      <label  style={{fontWeight:700}} className="form-label mt-0">Employer</label>
                      <div className="d-flex">
                        <label style={{fontWeight:700}} className="form-label flex-1 w-100 mt-0">
                          From Month
                        </label>
                        <label  style={{fontWeight:700}} className="form-label flex-1 w-100 mt-0">
                          From Year
                        </label>
                      </div>
                      <label  style={{fontWeight:700}} className="form-label mt-0">To Month</label>
                      <label  style={{fontWeight:700}} className="form-label mt-0">To Year</label>
                    </section>
                    {workHistoryList?.map((history) => {
                      return (
                        <>
                          {history?.name ||
                          history?.fromMonth ||
                          history?.fromYear ||
                          history?.toMonth ||
                          history?.toYear ? (
                            <section
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                                gap: "1.5rem",
                              }}
                            >
                              <label>{history?.name}</label>
                              <div className="d-flex ">
                                <label className="flex-1 w-100">
                                  {" "}
                                  {history?.fromMonth}
                                </label>
                                <label className="flex-1 w-100">
                                  {" "}
                                  {history?.fromYear}
                                </label>
                              </div>
                              <label> {history?.toMonth}</label>
                              <label>{history?.toYear}</label>
                            </section>
                          ) : null}
                        </>
                      );
                    })}
                  </>
                </div>
              ) : null}
            </>
          ) : (
            ""
          )}
          {educationList?.length ? (
            <>
              {educationList?.some(
                (edu) =>
                  edu?.name ||
                  edu?.fromMonth ||
                  edu?.fromYear ||
                  edu?.toMonth ||
                  edu?.toYear
              ) ? (
                <div>
                  <h4 className="view-heading">Education History</h4>
                  <>
                    <section
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                        gap: "1.5rem",
                      }}
                    >
                      <label  style={{fontWeight:700}} className="form-label mt-0">Education</label>
                      <div className="d-flex">
                        <label  style={{fontWeight:700}} className="form-label mt-0 flex-1 w-100">
                          From Month
                        </label>
                        <label  style={{fontWeight:700}} className="form-label mt-0 flex-1 w-100">
                          From Year
                        </label>
                      </div>
                      <label  style={{fontWeight:700}} className="form-label mt-0">To Month</label>
                      <label  style={{fontWeight:700}} className="form-label mt-0">To Year</label>
                    </section>

                    {educationList?.map((edu) => {
                      return (
                        <>
                          {edu?.name ||
                          edu?.fromMonth ||
                          edu?.fromYear ||
                          edu?.toMonth ||
                          edu?.toYear ? (
                            <section
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                                gap: "1.5rem",
                              }}
                            >
                              <label>{edu?.name}</label>
                              <div className="d-flex ">
                                <label className="flex-1 w-100">
                                  {" "}
                                  {edu?.fromMonth}
                                </label>
                                <label className="flex-1 w-100">
                                  {" "}
                                  {edu?.fromYear}
                                </label>
                              </div>
                              <label> {edu?.toMonth}</label>
                              <label>{edu?.toYear}</label>
                            </section>
                          ) : null}
                        </>
                      );
                    })}
                  </>
                </div>
              ) : null}
            </>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default NoResumeHistory;
